module.exports = __webpack_public_path__ + "img/1496505543.00904d8a.jpg";